import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMetronidazoleGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m28.24 21.68-1.23.19-.6-3.94-.09.57-.9 3.62-1.03.16-1.93-3.18-.26-.53.6 3.94-1.22.19-.95-6.23 1.41-.21L24.43 20l.19.34.09-.39 1.18-4.29 1.42-.22.93 6.24Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M8 23.02 17 10l15.8 1.05 6.9 14.48-8.95 13.15-15.94-1.23L8 23.02Zm7.66 13.26 14.52 1.12 8.15-11.98-6.28-13.18-14.39-.96-8.2 11.86 6.2 13.14Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m20.09 30.38-6.58-3.09 1.98-4.22 6.58 3.09-1.98 4.22Zm-4.91-3.69 4.32 2.03.92-1.96-4.32-2.02-.92 1.95ZM26.62 34.14l-2.73-4.73 6.22-3.59 2.73 4.73-6.22 3.59Zm-1.03-4.27 1.48 2.57 4.06-2.34-1.48-2.57-4.06 2.34Z",
    fill: "currentColor"
  }));
}

export { SvgMetronidazoleGlyph as default };
